import { get } from 'lodash';

export const getState = (state, param = null, defaultValue = null) => get(state, `noticeStage${(param ? `.${param}` : '')}`, defaultValue);
